import { useEffect, useMemo } from "react";
import { printResultToImage } from "../printResultToImage";
import { usePrint } from "./usePrint";

export const usePrintPreview = (openPreview: VoidFunction) => {
  const { startPrint, loading, printResult } = usePrint();

  const images = useMemo(
    () => (printResult && !loading ? printResult.map(printResultToImage) : []),
    [printResult, loading],
  );

  useEffect(() => {
    if (images.length) {
      openPreview();
    }
  }, [images]);

  return useMemo(() => ({ preview: startPrint, previewWaiting: loading, images }), [startPrint, images, loading]);
};
